import React, {useState} from 'react';
import {Footer, HeaderNavi, SupportLeftMenu, Pagination} from '@components';
import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';
import {  Link } from 'react-router-dom';

const fetchNoticeList = async (pageIndex, itemsPerPage) => {
    const response = await get('/noticeList', {
      params: {
        pageIndex,
        recordCountPerPage: itemsPerPage,
      },
    });
    return response;
  };
const NoticeList = () => {
    const [pageIndex, setPageIndex] = useState(1);
    const itemsPerPage = 10; 

    const { data, isLoading, isError } = useQuery({
        queryKey: ['noticeList', pageIndex],
        queryFn: () => fetchNoticeList(pageIndex, itemsPerPage),
        keepPreviousData: true,
    });
        
    const handlePageChange = (pageNumber) => {
        setPageIndex(pageNumber);
        };
    if (isLoading) {
        return <div>로딩 중...</div>;
    }
    
    if (isError) {
        return <div>오류가 발생했습니다</div>;
    }

    const combinedList = [
        ...(data?.resultListPinned || []),
        ...(data?.resultList || []),
    ];

  return (
    <main id="main" className="mainpage">
            <>
            <div>
                <div className="section main-contact">
                    <HeaderNavi  selectedCategory  />
                    <div className="sub-container">
                        <div className="sub-layout">
                            <SupportLeftMenu />
                            <div className="sub-contact">
                                <h3 className="border-bt" style={{ marginBottom: '0' }}>공지사항</h3>
                                <div className="lineTop_tb02">
                                    <table  className="lineTop_tb3">
                                    <colgroup>
                                    <col style={{ width: '50px' }} />
                                    <col style={{ width: '300px' }}/>
                                    <col style={{ width: '100px' }} />
                                    <col style={{ width: '100px' }}/>
                                    <col style={{ width: '50px' }}/>
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>번호</th>
                                            <th>제목</th>
                                            <th>등록일</th>
                                            <th>파일</th>
                                            <th>조회수</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {combinedList && combinedList.length > 0 ? (
                                    combinedList.map((item, index) => (
                                        <tr 
                                            key={item.noticeCode}
                                            className={item.isPinned === 1 ? 'pinned-notice' : ''}>
                                        <td className="text-cent">
                                            {item.isPinned === 1 ? (
                                            <span className="pinned-label">공지</span>
                                            ) : (
                                            (pageIndex - 1) * itemsPerPage + (index + 1 - (data.resultListPinned?.length || 0))
                                            )}
                                        </td>
                                        <td className="notice_title">
                                            <Link to={`/support/notice/detail?noticeCode=${item.noticeCode}`}>
                                            {item.title}
                                            </Link>
                                        </td>
                                        <td>{item.createdAt}</td>
                                        <td className="text-cent">{item.atchFileId ? <img src="/img/clip.png" alt="첨부파일"/> : '-'}</td>
                                        <td>{item.viewcount}</td>
                                        </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="5">공지사항이 없습니다.</td>
                                    </tr>
                                    )}
                                    </tbody>
                                    </table>
                                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                                        <Pagination
                                            totalPages={Math.ceil(
                                                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                                            )}
                                            currentPage={pageIndex}
                                            onPageChange={handlePageChange}
                                            pageRangeDisplayed={5} // 필요에 따라 조정
                                        />
                                    )}
                                </div>
                            </div>	
                        </div>	
                    </div>
                    <Footer />
                </div>
            </div>
        </>
   </main>


  );
};


export default NoticeList;
